var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pl-7 pr-6",attrs:{"fluid":""}},[_c('WorklistTable',{staticClass:"elevation-1 mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }